import React, {useState} from 'react';
import {t} from 'ttag';
import {AzoButton} from "../../../../index";
import {BOOK_FORM_REF} from "../../common/book-form-input-refs";
import {useSelector} from "react-redux";
import {Typography} from "@material-ui/core";
import {SW_FLIGHT_TYPES, SW_PASSENGER_TYPES} from "../../../../../store/types/index";
import CircularProgress from "@material-ui/core/CircularProgress";

const BookSubmitButtonConnected = () => {

    const [submitting, setSubmitting] = useState(false);
    const currentLanguage = useSelector(state => state.app.currentLanguage);
    const {
        origin = '',
        destination = '',
        departure = '',
        arrival = '',
        adults = '',
        children = '',
        infants = '',
        promoCode = '',
        passengerType = '',
        flightType = '',
        withMiles = false,
        multiCityLegs = [],
        multiCityIsValid = false,
    } = useSelector(state => state.sw.book);

    const canSubmit = (() => {
        switch (flightType) {
            case SW_FLIGHT_TYPES.RETURN:
                return origin
                    && destination
                    && departure
                    && arrival
                    && passengerType
                    && adults;
            case SW_FLIGHT_TYPES.ONE_WAY:
                return origin
                    && destination
                    && departure
                    && passengerType
                    && adults;
            case SW_FLIGHT_TYPES.MULTI:
                return Boolean(multiCityIsValid);
            default:
                return false;
        }
    })();

    const form = (() => {
        if (!canSubmit) return null;
        switch (flightType) {
            case SW_FLIGHT_TYPES.RETURN:
            case SW_FLIGHT_TYPES.ONE_WAY:
                const canSendPromoCode = !withMiles && ![SW_PASSENGER_TYPES.RESIDENT, SW_PASSENGER_TYPES.STUDENT].includes(passengerType);
                const parsedFlightType = withMiles
                    ? (flightType === SW_FLIGHT_TYPES.RETURN ? SW_FLIGHT_TYPES.RETURN_AWARD : SW_FLIGHT_TYPES.ONEWAY_AWARD)
                    : flightType;
                return (
                    <form method={'POST'}
                          action={`${process.env.REACT_APP_SUBMIT_URL}?lang=${currentLanguage.substring(0, 2)}`}
                          // target={'_blank'}
                          ref={BOOK_FORM_REF}>
                        <input type={'hidden'} name={'action'} value={'flightSearch'}/>
                        <input type={'hidden'} name={'flightType'} value={parsedFlightType}/>
                        <input type={'hidden'} name={'origin'} value={origin ? origin.code : ''}/>
                        <input type={'hidden'} name={'destination'} value={destination ? destination.code : ''}/>
                        <input type={'hidden'} name={'outboundDate'} value={departure}/>
                        <input type={'hidden'} name={'inboundDate'} value={flightType === SW_FLIGHT_TYPES.RETURN ? arrival : departure}/>
                        <input type={'hidden'} name={'paxType'} value={passengerType}/>
                        <input type={'hidden'} name={'numADT'} value={adults}/>
                        <input type={'hidden'} name={'numCHD'} value={children}/>
                        <input type={'hidden'} name={'numINF'} value={infants}/>
                        <input type={'hidden'} name={'utm_source'} value={'sataazores_PT'}/>
                        <input type={'hidden'} name={'utm_medium'} value={'referral'}/>
                        <input type={'hidden'} name={'utm_campaign'} value={'home_page_nav'}/>
                        <input type={'hidden'} name={'promoCode'} value={canSendPromoCode ? promoCode : ''}/>
                    </form>
                );
            case SW_FLIGHT_TYPES.MULTI:
                return (
                    <form method={'POST'}
                          action={`${process.env.REACT_APP_SUBMIT_URL}?lang=${currentLanguage.substring(0, 2)}`}
                          // target={'_blank'}
                          ref={BOOK_FORM_REF}>
                        <input type={'hidden'} name={'action'} value={'flightSearch'}/>
                        <input type={'hidden'} name={'flightType'} value={flightType}/>
                        {/*<input type={'hidden'} name={'origin'} value={origin ? origin.code : ''}/>*/}
                        {/*<input type={'hidden'} name={'destination'} value={destination ? destination.code : ''}/>*/}
                        {/*<input type={'hidden'} name={'outboundDate'} value={departure}/>*/}
                        <input type={'hidden'} name={'paxType'} value={SW_PASSENGER_TYPES.ADULT}/>
                        <input type={'hidden'} name={'numADT'} value={adults}/>
                        <input type={'hidden'} name={'numCHD'} value={children}/>
                        <input type={'hidden'} name={'numINF'} value={infants}/>
                        <input type={'hidden'} name={'utm_source'} value={'sataazores_PT'}/>
                        <input type={'hidden'} name={'utm_medium'} value={'referral'}/>
                        <input type={'hidden'} name={'utm_campaign'} value={'home_page_nav'}/>
                        {multiCityLegs.map((l, idx) => ([
                            <input key={`origin${idx}`} type={'hidden'} name={`origin${idx}`} value={l.origin ? l.origin.code : ''}/>,
                            <input key={`destination${idx}`} type={'hidden'} name={`destination${idx}`} value={l.destination ? l.destination.code : ''}/>,
                            <input key={`flightDate${idx}`} type={'hidden'} name={`flightDate${idx}`} value={l.departure || ''}/>
                        ]))}
                    </form>
                );
            default:
                return null;
        }
    })();

    const submitHandler = () => {
        try {
            setSubmitting(true);
            BOOK_FORM_REF.current.submit();
        } catch (e) {
            setSubmitting(false);
        }
    }

    return (
        <AzoButton
            onClick={submitHandler}
            disabled={!canSubmit || submitting}
            variant={'contained'}
            color={'secondary'}
            size={'large'}
            style={{maxWidth: '300px'}}
            disableElevation
            fullWidth
            tall>
            {canSubmit && form}
            {submitting ? <CircularProgress /> : <Typography variant={'h6'}>{t`Search`}</Typography>}
        </AzoButton>
    );
};

export default BookSubmitButtonConnected;